export default __webpack_public_path__ + "static/media/Daily.b907f515.gif";